import { tw } from "@careinfo/tailwind";
import { useFieldArray } from "react-hook-form";
import APIS from "../../constant/Endpoint";
import ComboboxInput from "../Reusable/ComboboxInput";
import FormDatePicker from "../Reusable/DateField";
import FileUpload from "../Reusable/FileUpload";
import NpDatePicker from "../Reusable/NepaliDatePicker";
import TextAreaField from "../Reusable/TextAreaField";
import TextField from "../Reusable/TextField";
import ServiceForm from "../Sales/ServiceForm";
import TradingForm from "./TradingForm";

const Form = (props: any) => {
  const {
    control,
    register,
    errors,
    getValues,
    setValue,
    clearErrors,
    companyData,
    isEdit,
    isDraft = true,
    watch,
    setOpenUserFormPopup,
  } = props;

  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });

  const handleAddRow = () => {
    append({
      account: "",
      hs_code: "",
      quantity: "",
      rate: "",
      amount: "",
      discount: "",
    });
  };

  return (
    <div className={tw`px-4`}>
      <div className={tw`grid grid-cols-4 mb-1 gap-x-4`}>
        <NpDatePicker
          label="Miti"
          name="voucher_date"
          disabled={!isDraft}
          disableFuture={true}
          value={watch("voucher_date")}
          setValue={setValue}
          error={errors?.voucher_date}
        />
        <FormDatePicker
          label="Date"
          name="voucher_date"
          disabled={!isDraft}
          control={control}
        />
        {isEdit ? (
          <TextField
            control={control}
            name="seq_no"
            label="Invoice Number"
            placeholder="Enter Invoice Number"
            disabled={true}
          />
        ) : (
          <TextField
            control={control}
            name="number_series"
            label="Invoice Number"
            placeholder="Enter Invoice Number"
            disabled={true}
          />
        )}
        <div className={tw`w-full flex items-start justify-center space-x-1`}>
          <ComboboxInput
            url={APIS.USER}
            queryKey="customer"
            label={"Customer Name"}
            props={{
              is_supplier: false,
            }}
            register={register("party")}
            errors={errors?.party}
            setValue={setValue}
            name={"party"}
            disabled={!isDraft}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <button
            className={tw`border px-3 py-1 text-xl leading-0 relative top-7  bg-[#EEF5F4] focus:outline-none`}
            type="button"
            onClick={() => setOpenUserFormPopup((prev) => !prev)}
          >
            +
          </button>
        </div>
      </div>
      {companyData?.type === "Trading" ? (
        <TradingForm
          fields={fields}
          register={register}
          errors={errors}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
          isDraft={isDraft}
          control={control}
          handleAddRow={handleAddRow}
          remove={remove}
        />
      ) : (
        <ServiceForm
          fields={fields}
          register={register}
          errors={errors}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
          isDraft={isDraft}
          control={control}
          handleAddRow={handleAddRow}
          remove={remove}
        />
      )}
      <div className={tw`grid grid-cols-2 gap-x-6`}>
        <TextField
          label="Reference Number"
          disabled={!isDraft}
          control={control}
          name={"reference_number"}
          placeholder="Enter reference number"
        />
        <NpDatePicker
          label="Reference Date"
          name="reference_date"
          disabled={!isDraft}
          value={watch("reference_date")}
          setValue={setValue}
          error={errors?.reference_date}
        />
        <FileUpload
          label="Attachment"
          register={register("attachment")}
          watch={watch}
          errors={errors}
          disabled={!isDraft}
          setValue={setValue}
        />
        <TextAreaField
          label="Narration"
          disabled={!isDraft}
          control={control}
          name={"narration"}
          placeholder="Write notes here..."
        />
      </div>
    </div>
  );
};

export default Form;

